import React from "react";
import { Box, useColorMode } from "@chakra-ui/react";
import LoginForm from "../components/LoginForm";

const Login = () => {
  const { colorMode } = useColorMode();

  return (
    <Box
      minH="100vh"
      bg={colorMode === "dark" ? "gray.800" : "gray.50"}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <LoginForm />
    </Box>
  );
};

export default Login;
